import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { VDP_IS_DRAFT } from "@/lib/policies/vdp-metadata";
interface LegalFooterProps {
  className?: string;
  /**
   * Which legal suffix to render after the shared copyright/terms/privacy/DPA
   * sentences (footer.legalCommon):
   * - "platform" (default): the not-an-investment-adviser sentences required
   *   on investor-facing pages.
   * - "chat": the general-purpose web chat (AIR-1167) — a generic AI-accuracy
   *   note, without the investment-specific language.
   */
  variant?: "platform" | "chat";
}
export function LegalFooter(t0) {
  const $ = _c(15);
  const {
    className,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "platform" : t1;
  const t = useTranslations("footer");
  const t2 = className ?? "w-full p-0 sm:py-1 sm:px-4 text-center text-[8px] text-muted-foreground/70 leading-tight";
  let t3;
  if ($[0] !== t) {
    t3 = t.rich("legalCommon", {
      terms: _temp,
      privacy: _temp2,
      dpa: _temp3
    });
    $[0] = t;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t) {
    t4 = !VDP_IS_DRAFT && <>{t.rich("legalSecurity", {
        security: _temp4
      })}{" "}</>;
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t) {
    t5 = t.rich("legalReport", {
      report: _temp5
    });
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = variant === "chat" ? "legalChatSuffix" : "legalPlatformSuffix";
  let t7;
  if ($[6] !== t || $[7] !== t6) {
    t7 = t(t6);
    $[6] = t;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t7) {
    t8 = <footer className={t2}>{t3}{" "}{t4}{t5}{" "}{t7}</footer>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp5(chunks_3) {
  return <Link href="/report" className="underline hover:text-muted-foreground">{chunks_3}</Link>;
}
function _temp4(chunks_2) {
  return <Link href="/security" className="underline hover:text-muted-foreground">{chunks_2}</Link>;
}
function _temp3(chunks_1) {
  return <Link href="/legal/dpa" className="underline hover:text-muted-foreground">{chunks_1}</Link>;
}
function _temp2(chunks_0) {
  return <Link href="/privacy-policy" className="underline hover:text-muted-foreground">{chunks_0}</Link>;
}
function _temp(chunks) {
  return <Link href="/legal/terms" className="underline hover:text-muted-foreground">{chunks}</Link>;
}